import React from 'react';
import { PROVIDER_OPTIONS } from '../../../../../constants/index';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';
import { useSelector } from 'react-redux';

export const ProviderFilter = ({ value, onChange, ...otherProps }) => {
  const selectedValue = PROVIDER_OPTIONS.filter((e) => e.value === value)[0];
  const allFilters = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams.filters,
  );
  const { Provider } = allFilters;
  return (
    <AutoSuggestionSelectComponent
      placeholder={Provider === 'facility' ? 'Facilities' : 'Doctors'}
      options={PROVIDER_OPTIONS}
      components={{ IndicatorSeparator: () => null }}
      value={selectedValue}
      onChange={onChange}
      {...otherProps}
      isSearchable={false}
      inputClassName="best-match-filter height-32"
    />
  );
};
